import type {TCreateMinorActionData} from '@kapitalist/contract/types'
import type {AnyMinorAction} from '~/models/game/types'

export const toCreateMinorActionData = (
  minorAction: AnyMinorAction
): TCreateMinorActionData => {
  const {datasource} = minorAction

  if (datasource.type === 'acquiesce') {
    const {minorActorPlayerId, prevailingPlayerId, ...rest} = datasource
    return rest
  } else {
    const {minorActorPlayerId, ...rest} = datasource
    return rest
  }
}
